import React from 'react';

/**
 *
 * @returns {리소스 다운로드}
 */

// record : 클릭한 파일 정보
const isDownload = (record) => {
  const requestOptions = {
    method: 'GET',
  };

  let urlData = record?.image_url || record?.sound_url;
  let resourceName = record?.image_name || record?.sound_name;
  const targetURL = urlData
    .replace(
      'https://carpestore.s3.amazonaws.com',
      'https://d3h4v3hjyy5iri.cloudfront.net',
    )
    .replace(
      'https://carpestore.s3.ap-northeast-2.amazonaws.com',
      'https://d3h4v3hjyy5iri.cloudfront.net',
    );

  fetch(targetURL, requestOptions)
    .then((response) => {
      console.log('response:', response.blob);
      return response.blob();
    })
    .then((blob) => {
      // image 확장명을 획득하자. => . 기준으로 문자열을 자른다.
      let urlSplit = urlData.split('.');
      // image 확장명만 추출 후, 대문자로 출력되는 경우가 있어서 소문자로 변환 시킨다.
      let imageFileType = urlSplit[urlSplit?.length - 1].toLowerCase();

      const url = window.URL.createObjectURL(blob); // 받아온 날 상태의 data를 현재 window에서만 사용하는 url로 바꾼다
      const a = document.createElement('a');
      a.href = url;
      a.download = `${resourceName}.${imageFileType}`;
      document.body.appendChild(a);
      a.click(); // 자동으로 눌러버리기
      setTimeout((_) => {
        window.URL.revokeObjectURL(url); // 해당 url을 더 사용 못하게 날려버린다
      }, 60000);
      a.remove(); // a를 다 사용했으니 지워준다
    })
    .catch((err) => {
      console.log(`err : `, err);
    });

  return <div></div>;
};

export default isDownload;
